import { render, staticRenderFns } from "./KdzGoodsConfigChoose.vue?vue&type=template&id=4e7fe65c&scoped=true"
import script from "./KdzGoodsConfigChoose.vue?vue&type=script&lang=js"
export * from "./KdzGoodsConfigChoose.vue?vue&type=script&lang=js"
import style0 from "./KdzGoodsConfigChoose.vue?vue&type=style&index=0&id=4e7fe65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7fe65c",
  null
  
)

export default component.exports